import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs';
import {
  PaymentAcceptanceRules,
  PaymentInclusionExclusionPayload,
  PaymentInclusionExclusionRulesResponseV1,
  PaymentRemittanceRulesApiResponse,
  PreAuthorizedDebitModeV1Response,
  RestrictionType,
} from '../models';

export abstract class PaymentAcceptanceRulesService {
  protected baseUrl: string;

  constructor(protected appConfig: AppConfigSettings) {
    this.baseUrl = this.appConfig.getconfig('paymentAcceptanceRulesServiceUrl');
  }

  getDefaultCardRestrictions(): PaymentInclusionExclusionRulesResponseV1 {
    return {
      restrictionType: RestrictionType.NoConfigFound,
      overrideRestriction: false,
      restrictionConfigurations: [],
      applications: [],
    };
  }

  abstract getPaymentAcceptanceRulesV1(
    tenantId: string,
    originApplication: string,
    cardMarsToken: string,
  ): Observable<PaymentAcceptanceRules>;

  abstract getCardInclusionExclusionListV1(
    payload: PaymentInclusionExclusionPayload,
  ): Observable<PaymentInclusionExclusionRulesResponseV1>;

  abstract getPaymentRemittanceRulesV1(
    tenantId: string,
  ): Observable<PaymentRemittanceRulesApiResponse>;

  abstract getPreAuthorizedDebitModeV1(
    tenantId: string,
  ): Observable<PreAuthorizedDebitModeV1Response>;
}
